import React from "react";
import {
  Controller,
  useFormContext,
  useWatch,
} from "react-hook-form";

import FindAndReplaceToggle from "../../common/FindAndReplaceToggle";
import NoteFormTypeToggle from "../../legacy/LegacyNoteFormTypeToggle";

export default function NoteFormOptions({ isAutoNote }) {
  const { control } = useFormContext();
  const shouldUseCustomForm = useWatch({
    control,
    name: "shouldUseCustomForm",
  });

  return (
    <>
      <div className="flex-1 flex flex-row items-center border dark:border-gray-700 rounded-lg divide-x dark:divide-gray-700 shadow-xs">
        <FindAndReplaceToggle isAutoNote={isAutoNote} />
        {/* Hide the form toggle for now ONLY FOR TYPED NOTES*/}
        {isAutoNote ? null : (
          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <NoteFormTypeToggle
                onChange={onChange}
                value={shouldUseCustomForm}
              />
            )}
            name="shouldUseCustomForm"
          />
        )}
      </div>
    </>
  );
}
